import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import { CampaignProcessComponent } from '../brands-and-agencies/campaign-process/campaign-process.component';
import { SignupPopupButtonComponent } from '../../components/signup-popup-button/signup-popup-button.component';

@Component({
  selector: 'app-influencers',
  standalone: true,
  imports: [
    CommonModule,
    CampaignProcessComponent,
    SignupPopupButtonComponent
  ],
  templateUrl: './influencers.component.html',
  styleUrls: ['./influencers.component.scss']
})
export class InfluencersComponent implements OnInit {
  isPlaying: Boolean = false;

  constructor(
    private titleService: Title, 
    private metaService: Meta
  ) {
    this.titleService.setTitle("Top Influencer Platform for Creators Community | Brandripplr");
    this.metaService.updateTag({ 
      name: 'description', 
      content: 'Discover the best influencer platform for creators. Join our creator community and connect with brands for paid collaborations today.' 
    });
  }

  playPause() {
    const myVideo = document.getElementById("my_video_1") as HTMLVideoElement;
    if (myVideo.paused) { 
      this.isPlaying = true;
      myVideo.play();
    } else {
      this.isPlaying = false;
      myVideo.pause();
    }
  }

  ngOnInit(): void {
  }

}
